import { api } from '../lib/request';

export async function fetchLeadDashboard(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
  });
  const response = await api.get(`/leads?${query.toString()}`);
  return response?.result || response;
}
